import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { type CartStore } from '../model';
import { useCartStoreContext } from '../provider';

const useSubscribeCartStoreWithShallow = <T,>(selector: (store: CartStore) => T) => {
  const storeContext = useCartStoreContext();

  return useStore(storeContext, selector);
};

const useSubscribeCartStoreShallow = <T,>(selector: (store: CartStore) => T) => {
  const storeContext = useCartStoreContext();

  return useStore(storeContext, useShallow(selector));
};

const useGetCartStore = <T,>(selector: (store: CartStore) => T) => {
  const storeContext = useCartStoreContext();

  return selector(storeContext.getState());
};

const useCartStoreActions = () => {
  const storeContext = useCartStoreContext();

  const state = storeContext.getState();

  return {
    addItem: state.addItem,
    removeItem: state.removeItem,
    incItemQuantity: state.incItemQuantity,
    decItemQuantity: state.decItemQuantity,
    clearCart: state.clearCart,
    setGoogleProfile: state.setGoogleProfile,
  };
};

export {
  useCartStoreActions,
  useGetCartStore,
  useSubscribeCartStoreWithShallow,
  useSubscribeCartStoreShallow,
};
